import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { mapValues, some } from 'lodash';
import { FieldArray } from 'react-final-form-arrays';
import { Field } from 'react-final-form';
import { SelectField, ToggleField } from '@unite-us/ui';
import { DAYS_OF_THE_WEEK, getOverlaps, timeSlotsOptions } from '@unite-us/client-utils';
import ButtonAddField from '../../common/ButtonAddField';
import ButtonRemoveField from '../../common/ButtonRemoveField';
var ContactTimeslotsEdit = function ContactTimeslotsEdit(_ref) {
  var change = _ref.change,
    name = _ref.name,
    push = _ref.push,
    values = _valuesInstanceProperty(_ref);
  var _useState = useState(mapValues(values.timeslots, function () {
      return true;
    })),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  var _useState3 = useState(some(isChecked)),
    _useState4 = _slicedToArray(_useState3, 2),
    toggleSelectTimes = _useState4[0],
    setToggleSelectTimes = _useState4[1];
  var handleAddField = function handleAddField(lowercaseDay) {
    if (!values.timeslots || !values.timeslots[lowercaseDay]) {
      var _context;
      push(_concatInstanceProperty(_context = "".concat(name, ".")).call(_context, lowercaseDay), {
        start_time: '09:00',
        end_time: '17:00'
      });
    } else {
      var _context2;
      push(_concatInstanceProperty(_context2 = "".concat(name, ".")).call(_context2, lowercaseDay), {
        start_time: null,
        end_time: null
      });
    }
  };
  var handleRemoveField = function handleRemoveField(fields, index, lowercaseDay) {
    fields.remove(index);
    if (index === 0 && fields.length === 1) {
      setIsChecked(_objectSpread(_objectSpread({}, isChecked), {}, _defineProperty({}, lowercaseDay, !isChecked[lowercaseDay])));
    }
  };
  var handleDayCheckbox = function handleDayCheckbox(lowercaseDay) {
    if (!isChecked[lowercaseDay]) {
      handleAddField(lowercaseDay);
    } else {
      var _context3;
      change(_concatInstanceProperty(_context3 = "".concat(name, ".")).call(_context3, lowercaseDay));
    }
    setIsChecked(_objectSpread(_objectSpread({}, isChecked), {}, _defineProperty({}, lowercaseDay, !isChecked[lowercaseDay])));
  };
  var onChangeStartTime = function onChangeStartTime(fields, index) {
    // If start_time values changes to a time later than end_time value, clear the end_time value.
    var startTimeValue = fields.value[index].start_time;
    var endTimeValue = fields.value[index].end_time;
    if (startTimeValue && endTimeValue && endTimeValue <= startTimeValue) {
      fields.update(index, {
        start_time: startTimeValue,
        end_time: null
      });
    }
  };
  var validateContactHours = function validateContactHours(value) {
    if (value) {
      var overlaps = getOverlaps(_mapInstanceProperty(value).call(value, function (timeslot) {
        return {
          start_time: {
            value: timeslot.start_time
          },
          end_time: {
            value: timeslot.end_time
          }
        };
      }));
      return _mapInstanceProperty(value).call(value, function (_, index) {
        if (overlaps[index]) {
          return {
            start_time: 'Times cannot overlap',
            end_time: true
          };
        }
        return undefined;
      });
    }
    return undefined;
  };
  var validateRequired = function validateRequired(value) {
    if (!value) return 'Required';
    return undefined;
  };
  var handleSelectTimesToggle = function handleSelectTimesToggle() {
    change(name);
    setIsChecked({});
    setToggleSelectTimes(!toggleSelectTimes);
  };
  var filterTime = function filterTime(search, startTime) {
    return new _Promise(function (resolve) {
      var _context4, _context5;
      var regex = new RegExp("^".concat(search, "\\b"), 'i');
      var filteredOptions = startTime ? _filterInstanceProperty(_context4 = timeSlotsOptions(startTime)).call(_context4, function (time) {
        return regex.test(time.label);
      }) : _filterInstanceProperty(_context5 = timeSlotsOptions()).call(_context5, function (time) {
        return regex.test(time.label);
      });
      resolve({
        options: filteredOptions
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "contact-hours-edit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lg:w-3/4 sm:w-auto"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "contact-requirements___selected-times-toggle",
    className: "w-full mb-2 ui-form-field__label"
  }, "Times To Contact"), /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement(ToggleField, {
    id: "is-active-toggle",
    label: "Selected Contact Times",
    className: "toggle-blue",
    checked: toggleSelectTimes,
    labelPosition: "left",
    onChange: function onChange() {
      handleSelectTimesToggle(change);
    }
  }))), toggleSelectTimes ? /*#__PURE__*/React.createElement("div", {
    className: "px-6 pt-6 border border-solid rounded border-dark-pale-blue"
  }, _mapInstanceProperty(DAYS_OF_THE_WEEK).call(DAYS_OF_THE_WEEK, function (day) {
    var _context6, _context7;
    var lowercaseDay = day.toLowerCase();
    return /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-5",
      key: "contact-hours-edit-".concat(lowercaseDay)
    }, /*#__PURE__*/React.createElement("div", {
      className: "pt-2 ui-checkbox-field h-14"
    }, /*#__PURE__*/React.createElement("input", {
      id: "contact-hours-edit-checked-".concat(lowercaseDay),
      type: "checkbox",
      checked: isChecked[lowercaseDay],
      onChange: function onChange() {
        return handleDayCheckbox(lowercaseDay);
      }
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: "contact-hours-edit-checked-".concat(lowercaseDay),
      className: "ui-form-field__label"
    }, day)), /*#__PURE__*/React.createElement(FieldArray, {
      name: _concatInstanceProperty(_context6 = "".concat(name, ".")).call(_context6, lowercaseDay),
      key: _concatInstanceProperty(_context7 = "".concat(name, ".")).call(_context7, lowercaseDay),
      validate: validateContactHours
    }, function (_ref2) {
      var fields = _ref2.fields;
      return _mapInstanceProperty(fields).call(fields, function (day_of_week, index) {
        var _context10;
        return /*#__PURE__*/React.createElement(React.Fragment, null, index > 0 && /*#__PURE__*/React.createElement("div", {
          className: "w-32"
        }), isChecked[lowercaseDay] && /*#__PURE__*/React.createElement("div", {
          className: "flex justify-start col-span-3 gap-2 px-0",
          "data-testid": "contact-hours-edit-row",
          key: day_of_week
        }, /*#__PURE__*/React.createElement(Field, {
          name: "".concat(day_of_week, ".start_time"),
          validate: function validate(value) {
            return validateRequired(value);
          }
        }, function (params) {
          var _context8;
          return /*#__PURE__*/React.createElement(SelectField, _extends({
            className: "w-32",
            clearable: false,
            hideLabel: true,
            id: _concatInstanceProperty(_context8 = "contact-hours-edit-start-".concat(lowercaseDay, "-")).call(_context8, index),
            label: "Start Time",
            options: timeSlotsOptions(),
            onChange: function onChange() {
              return onChangeStartTime(fields, index);
            },
            placeholder: "Start",
            loadOptions: function loadOptions(search) {
              return filterTime(search);
            },
            required: true,
            shouldSort: false
          }, params));
        }), /*#__PURE__*/React.createElement("div", {
          className: "pt-2"
        }, "to"), /*#__PURE__*/React.createElement(Field, {
          name: "".concat(day_of_week, ".end_time"),
          validate: function validate(value) {
            return validateRequired(value);
          }
        }, function (params) {
          var _context9;
          return /*#__PURE__*/React.createElement(SelectField, _extends({
            className: "w-32",
            clearable: false,
            hideLabel: true,
            id: _concatInstanceProperty(_context9 = "contact-hours-edit-end-".concat(lowercaseDay, "-")).call(_context9, index),
            label: "End Time",
            options: timeSlotsOptions(fields.value[index].start_time),
            placeholder: "End",
            loadOptions: function loadOptions(search) {
              return filterTime(search, fields.value[index].start_time);
            },
            required: true,
            shouldSort: false
          }, params));
        }), /*#__PURE__*/React.createElement("div", {
          className: "pt-1"
        }, /*#__PURE__*/React.createElement(ButtonRemoveField, {
          onClick: function onClick() {
            return handleRemoveField(fields, index, lowercaseDay);
          },
          testId: _concatInstanceProperty(_context10 = "contact-hours-edit-remove-".concat(lowercaseDay, "-")).call(_context10, index)
        }))), index > 0 && /*#__PURE__*/React.createElement("div", {
          className: "w-32"
        }));
      });
    }), isChecked[lowercaseDay] ? /*#__PURE__*/React.createElement("div", {
      className: "col-start-5 row-start-1 px-0 pt-2.5 justify-self-end"
    }, /*#__PURE__*/React.createElement(ButtonAddField, {
      label: "Add Timeslot",
      onClick: function onClick() {
        return handleAddField(lowercaseDay);
      }
    })) : /*#__PURE__*/React.createElement("div", {
      className: "pt-2 font-regular-font"
    }, "Do not contact"));
  })) :
  /*#__PURE__*/
  // closes toggleSelectTimes ternary
  React.createElement("div", {
    className: "h-175px"
  }));
};
ContactTimeslotsEdit.propTypes = {
  change: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  push: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired
};
export default ContactTimeslotsEdit;
//# sourceMappingURL=ContactTimeslotsEdit.js.map